


$(document).ready(function() {


  
  // $('.custom-float .float-icon').click(function(){
  //   $(this).hide();
  //   $('.custom-float .float-close').css('display', 'flex');
  //   $('.custom-float .custom-float-content').fadeIn(500);
  // })
  
  // $('.custom-float .float-close').click(function(){
  //     $(this).hide();
  //     $('.custom-float .float-icon').css('display', 'flex');
  //     $('.custom-float .custom-float-content').hide();
  // });
  
  $('.custom-popup-2').fadeIn(200);

  $('.custom-popup-2').click(function(){
      $('.custom-popup-2').fadeOut(200);
  });


    // $(document).ready(function() {
    //     // Add click event handler for close button
    //     $('.custom-popup').click(function() {
    //         $('.custom-popup').addClass('hidden'); // Add 'hidden' class to hide the popup
    //     });
    // });


  
    //   $(document).ready(function() {
    //     // Add click event handler for close button
    //     $('.custom-popup').click(function() {
    //         $('.Second-pop-offer').addClass('sconds'); // Add 'hidden' class to hide the popup
    //     });
    // });
  
    //   $(document).ready(function() {
    //     // Add click event handler for close button
    //     $('.close-custom-pop2').click(function() {
    //         $('.Second-pop-offer').addClass('third'); // Add 'hidden' class to hide the popup
    //     });
    // });
  
  // $('.custom-popup-2').click(function(){
  //     $(this).css('transform', 'rotateY(180deg)');
  //     $(this).hide();
  //     // $('.custom-popup-2 .second-popup').fadeIn(800);
  //     $('.custom-popup-2  .close-custom-pop').css('transform', 'rotateY(0deg)')
  // });

// $(document).ready(function() {
//     $('.close-custom-pop').click(function() {
//         $('.homepage-popup').addClass('rotated');
//         setTimeout(function() {
//             $('.homepage-popup').css('display', 'none');
//         }, 300); // Adjust the time to match your CSS transition duration
//     });
// });
  

  $('.mb-menu .mb-menu-dropdown').click(function(){

      $(this).find('ul').slideToggle();
    
  });
  
  // Butterfly Section JS
  
  var newWindowWidth = $(window).width();

  if(newWindowWidth > 760) {

    $('.home-fly').css('background', '#212121');

     

    $(".home-fly").on('mouseenter', '.home-feather img', function() {
          var targetDivId = $(this).parent().data('target');
          $('.feather-main-content').hide();
          $('#' + targetDivId).css('display', 'flex');
          if(targetDivId == 'purple-feather-data') {
            $(this).parent().parent().parent().css('background', '#422878');
          }
          else if(targetDivId == 'orange-feather-data') {
            $(this).parent().parent().parent().css('background', '#e87f31');
          }
          else if(targetDivId == 'green-feather-data') {
            $(this).parent().parent().parent().css('background', '#30968e');
          }
          else {
            $(this).parent().parent().parent().css('background', '#CC0018');
          }
      });
      $(".home-fly").on('mouseleave', '.home-feather img', function() {
          $('.feather-main-content').hide();
          $('.red-feather-content.feather-main-content').css('display', 'flex');
          $('.home-fly').css('background', '#212121');
      });


    

    }

  else {

     $('.home-fly').css('background', '#212121');

    $('.home-feather').click(
            function(){
                var targetDivClick = $(this).data('target');
                
                if($(this).hasClass("show_dot")){
                  $(this).removeClass('show_dot');
                  $(this).siblings().addClass('show_dot');
                }
                else if(!$(this).hasClass("show_dot")){
                  $(this).removeClass('show_dot');
                } 
                else {
                  $('.home-feather').addClass('show_dot');
                }
                $('.feather-main-content').hide();
                $('#' + targetDivClick).css('display', 'flex');

              if(targetDivClick == 'purple-feather-data') {
                  $(this).parent().parent().css('background', '#422878');
                }
                else if(targetDivClick == 'orange-feather-data') {
                  $(this).parent().parent().css('background', '#e87f31');
                }
                else if(targetDivClick == 'green-feather-data') {
                  $(this).parent().parent().css('background', '#30968e');
                }
                else {
                  $(this).parent().parent().css('background', '#CC0018');
                }
              
            },
        );
    
  }


  // Event Page JS
  
  $('.events-tab span').click(
      function(){
          var eventClick = $(this).data('id');
          
          $('.events-tiles').hide();
          $('#' + eventClick).css('display', 'flex');

          if($(this).hasClass('active_tab')){
              $('.events-tab span').removeClass('active_tab');
          } else {
              $(this).addClass('active_tab');
          }

      },
  );

  $('.events-tab span[data-id="tab1"]').click();
   


  // Contact Us JS
  
  $('.contact-questions .contact-q .contact-faq-label').click(function(){
      
      $(this).siblings().slideToggle();
      $(this).parent().toggleClass('opn_contact_faq');
      
  });



  
  $('form#contact_form_page input.t4s-btn').click(function(){
  
      var contact_dropdown = $('form#contact_form_page select option:selected').val();
  
      if(contact_dropdown == '') {
          return false;
      }
      else {
          return true;
      }
      
  });





  // Store Finder JS

        
    $('.store-finder-tabs span').click(
        function(){
            var storeClick = $(this).data('id');
            
            $('.store-list').hide();
            $('#' + storeClick).css('display', 'flex');

            if($(this).hasClass('inactive')){
                $('.store-finder-tabs span').addClass('inactive');           
                $(this).removeClass('inactive');
            }

        }
    );

    $('.store-finder-tab span:not(:first)').addClass('inactive');

    $('.store-finder-tabs span[data-id="tab1"]').click();




    
    $("#store-search").on("input", function() {
        var searchText = $(this).val().trim().toLowerCase();
        $("ul li.store-box").each(function() {
        var dataId = $(this).data("tag").toLowerCase();
        if (dataId.includes(searchText)) {
            $(this).show();
        } else {
            $(this).hide();
        }
        });
    });











  $('.recomended-stores .store-list li.store-box').hide().filter(':lt(3)').show();
  var ul = document.querySelector('.recomended-stores .store-list');
  for (var i = ul.children.length; i >= 0; i--) {
      ul.appendChild(ul.children[Math.random() * i | 0]);
  }



  var recomendStore = $(".recomended-stores .store-list li.store-box");
  var numberOfStoresToShow = 5;
  var numberOfStoresToShowInMobile = 4;
  
  // Function to shuffle array
  function shuffle(array) {
      for (var i = array.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var temp = array[i];
          array[i] = array[j];
          array[j] = temp;
      }
      return array;
  }
  
  // Shuffle the list items
  recomendStore = shuffle(recomendStore);
  
  // Hide all list items
  recomendStore.hide();
  
  // Show randomly selected items

  if(newWindowWidth > 760) {
  
    recomendStore.slice(0, numberOfStoresToShow).show();
    
  }
    
  else {

    recomendStore.slice(0, numberOfStoresToShowInMobile).show();
    
  }
  
  
  
});



// Show popup after 3 seconds
    setTimeout(() => {
        document.querySelector('.main-popup').style.display = 'block';
    }, 2500);

    // // Close popup functionality
    // document.querySelector('.close-popup').addEventListener('click', () => {
    //     document.querySelector('.main-popup').style.display = 'none';
    // });

    // // Close popup if the overlay is clicked
    // document.querySelector('.bg-overlay').addEventListener('click', () => {
    //     document.querySelector('.main-popup').style.display = 'none';
    // });


// When the close button in popup-area is clicked, hide popup-area and show popup-area2
    document.querySelector('.close-popup').addEventListener('click', function() {
        document.querySelector('.popup-area').classList.add('hide');  // Add 'hide' class to popup-area
        document.querySelector('.popup-area2').classList.add('active');  // Add 'active' class to popup-area2
    });

    // Optional: Close popup-area2 functionality (if you want to close it using the second close button)
    document.querySelector('.close-popup2').addEventListener('click', function() {
        document.querySelector('.popup-area2').classList.remove('active');  // Remove 'active' class from popup-area2
        document.querySelector('.popup-area').classList.remove('hide');  // Remove 'hide' class from popup-area
        document.querySelector('.main-popup').style.display = 'none';
        document.querySelector('.float-icon').classList.add('active');
    });


 // Show popup-area when float-icon is clicked
    document.querySelector('.float-icon').addEventListener('click', function() {
        document.querySelector('.main-popup').style.display = 'block';
        document.querySelector('.popup-area').classList.add('hide');
        document.querySelector('.popup-area2').style.display = 'block';
        document.querySelector('.float-icon').classList.remove('active');  // Hide the float icon
    });







